import API from 'services/api';

export const notificationMarkAsUnRead = ({ payload }: { payload: string[] }) =>
  API.post('/api/notifications/markAsUnRead', payload);
